import type {SVGProps} from 'react'
const SvgStamp = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="-2 -2 45 44" {...props}>
    <path
      fill="url(#stamp_svg__a)"
      fillRule="evenodd"
      d="M2.376 34.429c0-1.277-1.064-2.312-2.376-2.312v-2.626c1.312 0 2.376-1.035 2.376-2.311S1.312 24.869 0 24.869v-2.627c1.312 0 2.376-1.035 2.376-2.311S1.312 17.619 0 17.619v-2.626c1.312 0 2.376-1.035 2.376-2.311S1.312 10.37 0 10.37V7.744c1.312 0 2.376-1.035 2.376-2.311S1.312 3.122 0 3.122V0h3.209c0 1.276 1.063 2.31 2.375 2.31S7.959 1.277 7.959 0h2.7c0 1.276 1.064 2.31 2.376 2.31S15.41 1.277 15.41 0h2.7c0 1.276 1.063 2.31 2.375 2.31S22.861 1.277 22.861 0h2.7c0 1.276 1.063 2.31 2.375 2.31S30.311 1.277 30.311 0h2.7c0 1.276 1.063 2.31 2.375 2.31S37.762 1.277 37.762 0h3.209v3.122c-1.312 0-2.376 1.034-2.376 2.31s1.064 2.312 2.376 2.312v2.627c-1.312 0-2.376 1.035-2.376 2.31 0 1.277 1.064 2.312 2.376 2.312v2.626c-1.312 0-2.376 1.035-2.376 2.312s1.064 2.31 2.376 2.31v2.628c-1.312 0-2.376 1.034-2.376 2.31s1.064 2.312 2.376 2.312v2.626c-1.312 0-2.376 1.035-2.376 2.312s1.064 2.31 2.376 2.31v3.123h-3.21c0-1.277-1.063-2.312-2.375-2.312s-2.375 1.035-2.375 2.311h-2.7c0-1.276-1.063-2.31-2.375-2.31s-2.375 1.034-2.375 2.31h-2.7c0-1.276-1.064-2.31-2.376-2.31s-2.375 1.034-2.375 2.31h-2.7c0-1.276-1.063-2.31-2.375-2.31s-2.376 1.034-2.376 2.31h-2.7c0-1.276-1.063-2.31-2.375-2.31s-2.375 1.034-2.375 2.31H0V36.74c1.312 0 2.376-1.034 2.376-2.31"
      clipRule="evenodd"
    />
    <defs>
      <linearGradient
        id="stamp_svg__a"
        x1={72.985}
        x2={135.302}
        y1={84.953}
        y2={-48.506}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4F0668" />
        <stop offset={0.312} stopColor="#12A391" />
        <stop offset={1} stopColor="#4F0668" />
      </linearGradient>
    </defs>
  </svg>
)
export default SvgStamp
